import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { keyById } from '../../popupCompanyList/listCompany/helper'
import { getDetailData } from './thunk'

const initialState = {
  companyById: {},
  companyIds: [],
  companyDetailPagination: {},
  filter: {
    page: 1,
    pageSize: 20,
  },

  loading: true,
}

const slice = createSlice({
  name: 'portfolioInsights/handleDetail',
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDetailData.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getDetailData.fulfilled, (state, action) => {
      state.companyIds = (action.payload.data || []).map(
        (i) => i.organizationId,
      )
      state.companyById = keyById(action.payload.data || [])
      state.companyDetailPagination = action.payload
      state.loading = false
    })
    builder.addCase(getDetailData.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const { resetStore, changeFilter } = slice.actions

export const selectCell = (rowId, colId) => (state) => {
  return state[slice.name].companyById[rowId][colId]
}
export const selectCompanyIds = (state) => {
  return state[slice.name].companyIds
}
export const selectLoading = (state) => state[slice.name].loading
export const selectCompanyDetailPagination = (state) =>
  state[slice.name].companyDetailPagination
export const selectFilter = (state) => state[slice.name].filter

register(slice.name, slice.reducer)
